var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.28068 13.6271C2.72805 13.6271 2.18156 13.492 1.64121 13.2219C1.10086 12.9517 0.664892 12.5955 0.333313 12.1534C0.652611 12.1534 0.97805 12.0276 1.30963 11.7758C1.64121 11.524 1.807 11.1587 1.807 10.6798C1.807 10.0657 2.02191 9.54379 2.45173 9.11396C2.88156 8.68414 3.40349 8.46922 4.01752 8.46922C4.63156 8.46922 5.15349 8.68414 5.58331 9.11396C6.01314 9.54379 6.22805 10.0657 6.22805 10.6798C6.22805 11.4903 5.93945 12.1841 5.36226 12.7613C4.78507 13.3385 4.09121 13.6271 3.28068 13.6271ZM7.51752 9.20607L5.49121 7.17975L12.0859 0.585013C12.221 0.449926 12.3899 0.379312 12.5925 0.373171C12.7952 0.367031 12.9702 0.437645 13.1175 0.585013L14.1123 1.57975C14.2596 1.72712 14.3333 1.89905 14.3333 2.09554C14.3333 2.29203 14.2596 2.46396 14.1123 2.61133L7.51752 9.20607Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrush);
export default __webpack_public_path__ + "static/media/brush.4697f7223d7a77332ef33da1e1ac1da1.svg";
export { ForwardRef as ReactComponent };